import initGrid from '@components/filterable-grid.js';

import '@css/blocks/program.pcss';

(function () {
  const blocks = [...document.querySelectorAll('.block--type-program')];

  blocks.forEach((block) => {
    initGrid(block);
  });
})();
